// @ts-strict-ignore
import mapValues from 'lodash/mapValues';

import {Organization as OrganizationMetadata, User as UserMetadata} from 'app_api/me/types';
import {UserFeatureFlag} from 'common/report/constants';
import {purgeFetchCache} from 'common/report/queries/utils/fetch-cache';
import {apiClient} from 'common/util/api-client';
import {ApiResourceClient} from 'common/util/model-resource/api-resource';

import {appApiUrl} from '../utils';

export type Organization = OrganizationMetadata & {
  isDemo: boolean;
};

export class CurrentUser {
  public declare bio: string;
  // NOTE: from what I can tell, this does not seem to be in UTC time; rather it's in local time (presumably of
  // server location)
  public declare dateJoinedIso: string;
  public declare email: string;
  public declare id: number;
  public declare isGuest: boolean;
  public declare isStaff: boolean;
  public declare loginFlow: string;
  public declare myDashboardId?: number;
  public declare name: string;
  public declare organizations: Record<string, Organization>;
  public declare pendingEmail: string;
  public declare phone: string;
  public declare current_twofactor_method?: string | null;

  // TODO does this need to be in CurrentUser?
  // workspaces: Record<string, WorkspaceObj>;

  private declare featureFlags: Set<string>;

  constructor(userAttrs: UserMetadata) {
    this.bio = userAttrs.user_bio;
    this.dateJoinedIso = userAttrs.date_joined_iso;
    this.email = userAttrs.user_email;
    this.id = userAttrs.user_id;
    this.isGuest = userAttrs.is_guest;
    this.isStaff = userAttrs.is_staff;
    this.loginFlow = userAttrs.user_login_flow;
    this.myDashboardId = userAttrs.my_dashboard_id;
    this.name = userAttrs.user_name;
    this.organizations = mapValues(userAttrs.organizations, (organization) => ({
      isDemo: organization.is_demo,
      ...organization,
    }));
    this.pendingEmail = userAttrs.user_pending_email;
    this.phone = userAttrs.user_phone;

    this.featureFlags = new Set(userAttrs.feature_flags);
    this.current_twofactor_method = userAttrs.current_twofactor_method;
  }

  public hasFeatureFlag(flagName: UserFeatureFlag) {
    return this.featureFlags.has(flagName);
  }
}

// we don't hydrate workspaces on the model, so no need to get workspace users, which would make the call incredibly slow
const CURRENT_USER_PATH = appApiUrl(`me/?include_workspace_users=false`);
export const currentUserClient: ApiResourceClient<CurrentUser> = {
  index() {
    throw new Error(`currentUserClient does not support index queries`);
  },

  get() {
    const fetches = apiClient.hydratedGet<UserMetadata>(CURRENT_USER_PATH);
    return mapValues(fetches, (fetch) => fetch.then((userAttrs) => userAttrs && new CurrentUser(userAttrs)));
  },

  purgeCache() {
    purgeFetchCache({everything: true, path: CURRENT_USER_PATH});
  },
};
